<template>
  <template
    v-if="version === 'next' && $slots.next"
  >
    <slot name="next" />
  </template>
  <template v-else>
    <sb-banner
      v-if="$slots.next && showNextVersionWarning"
      variation="warning"
      :dismissable="true"
    >
      <sb-text
        :value="nextVersionWarning"
      />
    </sb-banner>
    <slot name="current" />
  </template>
</template>

<script>
import { ENV } from '@src/env';
import SbBanner from '@src/components/Banner/SbBanner.vue';
import SbText from '@src/components/Text/SbText.vue';

export default {
  components: {
    SbBanner,
    SbText,
  },
  props: {
    version: {
      type: String, // todo : CHANGE TO ENUM
      default: 'current',
    },
    nextVersionWarning: {
      type: String,
      default: `A new version of the component below is available. Add prop version='next' to try it out`,
    },
  },
  computed: {
    showNextVersionWarning() {
      return ENV.SHOW_NEXT_VERSION_WARNING;
    },
  },
  mounted() {
    if (this.version === 'next' && !this.$slots.next) {
      console.warn('Version prop is not needed');
    }
  },
};
</script>

<style>

</style>
